var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skin-display"},[_c('div',{staticClass:"skin-name"},[_c('span',[_vm._v(_vm._s(_vm.skinName))])]),_c('img',{style:(_vm.imageStyle),attrs:{"src":_vm.splashUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }